export enum PricingType {
    PURCHASE = 'PURCHASE', // (seulement prix d'achat)
    PURCHASE_COM = 'PURCHASE_COM', // (seulement prix d'achat et com)
    PURCHASE_MARKUP = 'PURCHASE_MARKUP', // (seulement prix d'achat et markup)
    PURCHASE_DETAILED = 'PURCHASE_DETAILED', // (prix d'achat, com et markup)
    SELLING = 'SELLING', // (seulement prix de vente)
    SELLING_COM = 'SELLING_COM', // (seulement prix de vente et com)
    SELLING_MARKUP = 'SELLING_MARKUP', // (seulement prix de vente et markup)
    SELLING_DETAILED = 'SELLING_DETAILED', // (prix de vente, com et markup)
    SELLING_TTC = 'SELLING_TTC', // (seulement prix de vente incluant la TVA)
    SELLING_COM_TTC = 'SELLING_COM_TTC', // (seulement prix de vente incluant la TVA et com)
    SELLING_MARKUP_TTC = 'SELLING_MARKUP_TTC', // (seulement prix de vente incluant la TVA et markup)
    SELLING_DETAILED_TTC = 'SELLING_DETAILED_TTC', // (prix de vente incluant la TVA, com et markup)
}